// src/shared/toast.js — съобщенията долу в средата (копие от app.js).
// ЗАДЪЛЖИТЕЛНО остава и на window.toast — registry-autofill.js го вика по име.
//
// Фаза А.2: грешките ОСТАВАТ на екрана до затваряне с „×" — изчезващо след
// 2,6 сек съобщение никой не успява да прочете, камо ли да разбере. Успехите
// продължават да изчезват сами. При отворена форма грешката се показва И в
// самата форма, до бутоните — човекът гледа там, не в ъгъла.

import { el, $ } from './dom.js';

export function toast(msg, isErr) {
  if (isErr) {
    formError(msg);
    const box = $('#toasts');
    // Еднаква грешка не се трупа на камара — един ред стига.
    if ([...box.querySelectorAll('.toast.err')].some((t) => t._msg === msg)) return;
    // role="alert" прекъсва четенето при грешка (нарочно — виж index.html).
    const t = el('div', { class: 'toast err', role: 'alert' },
      el('span', { text: msg }),
      el('button', { class: 'toast-x', type: 'button', 'aria-label': 'Затвори съобщението', onClick: () => t.remove() },
        el('span', { 'aria-hidden': 'true', text: '×' })));
    t._msg = msg;
    box.appendChild(t);
    return;
  }
  // Успех: обявява се учтиво през aria-live="polite" на самия #toasts.
  const t = el('div', { class: 'toast', text: msg });
  $('#toasts').appendChild(t);
  setTimeout(() => { t.style.opacity = '0'; t.style.transition = 'opacity .3s'; setTimeout(() => t.remove(), 300); }, 2600);
}

// Грешката се влива и в отворената форма. Най-горният прозорец Е формата:
// потвържденията (confirmDialog) се затварят преди самата заявка. Без role —
// ъгловото съобщение вече е alert, второ би дублирало прочита на четеца.
// Редът е един и се презаписва: старата грешка е вече невярна.
function formError(msg) {
  const overlays = $('#modal-root') ? [...$('#modal-root').children] : [];
  const top = overlays[overlays.length - 1];
  const foot = top && top.querySelector('.modal-foot');
  if (!foot) return;
  let line = foot.querySelector('.form-error');
  if (!line) { line = el('div', { class: 'form-error' }); foot.insertBefore(line, foot.firstChild); }
  line.textContent = msg;
}
